let logUrl = "https://log.goodreels.com/pclogpd.php"; // 点击、pv、event打点url
let exposureUrl = "https://log.goodreels.com/pclog_bgdj.php"; // 曝光url

import Axios from "axios";
let logAxios = Axios.create();

// import { getCookie } from "./cookie";
// import { logAddUserId } from "./common";
const lanMap = {
  en: "ENGLISH",
  id: "BAHASA_INDONESIA",
  th: "THAI",
  fr: "FRENCH",
  fi: "FILIPINO",
  ru: "RUSSIAN",
};
// try {
//   var deviceId = getCookie("visitor");
// } catch (error) { }

// if(process.env.NODE_ENV === 'development'){
//     logUrl = '/logApi/pclogpd.php'
//     exposureUrl = '/logApi/pclog_bgdj.php'
// }

/**
 * pv、uv打点类，data是传入的参数
 *
 * @export
 * @class LogPv
 */
class LogPv {
  constructor(data) {
    const windowNavigator = window.navigator;
    let location = window.location.href;
    data = data || {};
    this.data = {
      tag: 101, // tag=201是pv、uv，类型
      appName: windowNavigator.appName, // 浏览器的官方名称
      appVersion: windowNavigator.appVersion, // 表示浏览器的版本
      platform: windowNavigator.platform, // 表示浏览器的所在系统平台
      product: windowNavigator.product, // 当前浏览器的产品名称
      userAgent: windowNavigator.userAgent, // 当前浏览器的用户代理字符串
      // url: window.location.href, // 当前页面也的地址
      sw: window.screen.width, // 获取屏幕分辨率的宽度
      sh: window.screen.height, // 获取屏幕分辨率的高度
      prev: data.prev || "", // 上一个页面非必填
      ptype: data.ptype || "", // 当前页面必填
      // deviceId: deviceId, // 唯一标识符
      map: data.map || {}, // 其他非必填参数
    };
    this.data.map.platform = "PC";
    this.data.map.chid = sessionStorage.getItem("chid") || "GSWEB00001";
    this.data.map.cc = localStorage.getItem("channelCode") || "GSWEB00001";
    this.data.map.language = lanMap[localStorage.getItem("language")];
    this.data.map.url = location.indexOf("?json=") ? location.split("?json=")[0] : location;
    this.data.map.uuid = localStorage.getItem("UUID") || 0;
    // this.data.map.pid = window.localStorage.getItem("userInfo") ? JSON.parse(window.localStorage.getItem("userInfo")).id : localStorage.getItem("puid") || 0;
    // this.data = logAddUserId(this.data); //增加uid打点
    // this.data.map.gnsource = checkSource(); // 判断是 ios android m
    this.logPvAjax();
  }
  logPvAjax() {
    try {
      logAxios.get(logUrl + "?json=" + JSON.stringify(this.data));
    } catch (error) { }
  }
}
/**
 * 暴露出去的方法，pv、uv直接调用
 * @param {参数对象} data
 */
export const logPvFun = (data) => {
  new LogPv(data);
};

/**
 * 点击事件打点tag=102
 *
 * @class LogClick
 */
class LogClick {
  constructor(data) {
    const windowNavigator = window.navigator;
    let location = window.location.href;
    data = data || {};
    this.data = {
      tag: 102, // tag=202是点击事件打点类型
      appName: windowNavigator.appName, // 浏览器的官方名称
      appVersion: windowNavigator.appVersion, // 表示浏览器的版本
      platform: windowNavigator.platform, // 表示浏览器的所在系统平台
      product: windowNavigator.product, // 当前浏览器的产品名称
      userAgent: windowNavigator.userAgent, // 当前浏览器的用户代理字符串
      // url: window.location.href, // 当前页面也的地址
      sw: window.screen.width, // 获取屏幕分辨率的宽度
      sh: window.screen.height, // 获取屏幕分辨率的高度
      module: data.module || "", // 当前点击元素的所属页面
      zone: data.zone || "", // 点击的区域
      adid: data.adid || "", // 点击元素的id(例如书籍id之类)
      // deviceId: deviceId, // 唯一标识符
      map: data.map || {}, // 其他非必填参数
    };
    this.data.map.platform = "PC";
    this.data.map.chid = sessionStorage.getItem("chid") || "GSWEB00001";
    this.data.map.cc = localStorage.getItem("channelCode") || "GSWEB00001";
    this.data.map.language = lanMap[localStorage.getItem("language")];
    this.data.map.url = location.indexOf("?json=") ? location.split("?json=")[0] : location;
    this.data.map.uuid = localStorage.getItem("UUID") || 0;
    // this.data.map.pid = window.localStorage.getItem("userInfo") ? JSON.parse(window.localStorage.getItem("userInfo")).id : localStorage.getItem("puid") || 0;
    // this.data = logAddUserId(this.data); //增加uid打点
    // this.data.map.gnsource = checkSource(); // 判断是 ios android m
    this.logPvAjax();
  }
  logPvAjax() {
    try {
      logAxios.get(logUrl + "?json=" + JSON.stringify(this.data));
    } catch (error) { }
  }
}

export const logClickFun = (data) => {
  new LogClick(data);
};

/**
 * event 事件，tag=103
 *
 * @class LogEvent
 */
class LogEvent {
  constructor(data) {
    const windowNavigator = window.navigator;
    let location = window.location.href;
    data = data || {};
    this.data = {
      tag: 103, // tag=203是事件打点类型
      appName: windowNavigator.appName, // 浏览器的官方名称
      appVersion: windowNavigator.appVersion, // 表示浏览器的版本
      platform: windowNavigator.platform, // 表示浏览器的所在系统平台
      product: windowNavigator.product, // 当前浏览器的产品名称
      userAgent: windowNavigator.userAgent, // 当前浏览器的用户代理字符串
      // url: window.location.href, // 当前页面也的地址
      sw: window.screen.width, // 获取屏幕分辨率的宽度
      sh: window.screen.height, // 获取屏幕分辨率的高度
      event: data.event || "", // 事件名称：例如，czcg,fbcg
      // deviceId: deviceId, // 唯一标识符
      map: data.map || {}, // 其他非必填参数
    };
    this.data.map.platform = "PC";
    this.data.map.chid = sessionStorage.getItem("chid") || "GSWEB00001";
    this.data.map.cc = localStorage.getItem("channelCode") || "GSWEB00001";
    this.data.map.language = lanMap[localStorage.getItem("language")];
    this.data.map.url = location.indexOf("?json=") ? location.split("?json=")[0] : location;
    this.data.map.uuid = localStorage.getItem("UUID") || 0;
    // this.data.map.pid = localStorage.getItem("puid") || 0;
    // this.data = logAddUserId(this.data); //增加uid打点
    // this.data.map.gnsource = checkSource(); // 判断是 ios android m
    this.logPvAjax();
  }
  logPvAjax() {
    try {
      logAxios.get(logUrl + "?json=" + JSON.stringify(this.data));
    } catch (error) { }
  }
}

export const logEventFun = (data) => {
  new LogEvent(data);
};

// 判断是 ios  android  m

function checkSource() {
  let u = navigator.userAgent;
  let isiOS = !!u.match(/.+Mac OS X/); //ios终端
  if (isiOS) {
    if (window.webkit && !!window.webkit.messageHandlers && !!window.webkit.messageHandlers.logPv && !!window.webkit.messageHandlers.showRightTitle) {
      return "IOS";
    } else {
      return "M";
    }
  } else {
    if (window.WebApi && !!window.WebApi.logPv && !!window.WebApi.showRightTitle) {
      return "ANDROID";
    } else {
      return "M";
    }
  }
}
